import React from "react";
import { makeStyles, useId } from "@fluentui/react-components";
import { useCategoryDrawerStore } from "../store/CategoryDrawerStore";

const useStyles = makeStyles({
    drawerBody: {
        overflow: "hidden"
    },
    inputWrapper: {
        paddingBottom: "15px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        maxWidth: "400px",
        "> div": { display: "flex", flexDirection: "column", gap: "2px" },
    },
});

export default function useCategoryFormHook() {
    const styles = useStyles();
    const { isEdit, data } = useCategoryDrawerStore();

    const nameId = useId("category-name");
    const [name, setName] = React.useState<string>(isEdit && data ? data.name : "");

    return { styles, nameId, name, setName };
}